import { localesApp } from './app';
import { localesLogin } from './login';
import { localesMenu } from './menu';
import { localesSetting } from './setting';
import { localesCommon } from './common';
import { localesSales } from './sales';
import { localesAdvert } from './advert';
import { localesProcure } from './procure';
import { localesInvoice } from './invoice';
import { localesSubAccount } from './subAccount';
import { localesAdmin } from './admin';
import deepmerge from 'deepmerge';
import { localesShop } from './shop';
import { localesPermission } from './permission';
import { localesAlibaba } from './alibaba';
import { localesTools } from './tools';

// 合并所有语言数据
const localesData = deepmerge.all([
  localesLogin,
  localesMenu,
  localesSetting,
  localesApp,
  localesCommon,
  localesSales,
  localesAdvert,
  localesProcure,
  localesInvoice,
  localesSubAccount,
  localesAdmin,
  localesShop,
  localesPermission,
  localesAlibaba,
  localesTools,
]);

export default localesData;
